export default function readBlob(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.addEventListener('loadend', () => {
      resolve(reader.result)
    })
    reader.readAsText(blob)
  })
}
